// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"554":"OnfidoForm","653":"ProjectionsChart"}[chunkId] + "." + {"554":"24f8d2bf088ba66676fc","653":"f8eee44cf2375f71c8d4"}[chunkId] + ".css";
};